import type { Connection, CreateConnectionOptions } from '@lucidtech/las-sdk-browser';

import { create } from '@/hooks/api';
import { JSONType } from '@/utils';

export type ConnectionId = { connectionId: string };

export const {
  useGet: useGetConnection,
  useList: useListConnections,
  useCreate: useCreateConnection,
  useDelete: useDeleteConnection,
  useUpdate: useUpdateConnection,
  useInvalidateQueries: useInvalidateConnections,
} = create<Connection, ConnectionId, CreateConnectionOptions>({
  cacheKey: 'connections',
  equal: (connection, id) => Boolean(connection && id?.connectionId && connection.connectionId === id.connectionId),
  createId: (connection) => (connection ? { connectionId: connection.connectionId } : null),
  get: (client, id) => client.getConnection(id.connectionId),
  create: (client, connection) => client.createConnection(connection),
  delete: (client, id) => client.deleteConnection(id.connectionId),
  update: (client, id, updates) => client.updateConnection(id.connectionId, updates),
  list: (client) => {
    return new Promise((resolve, reject) => {
      client
        .listConnections()
        .then((response: JSONType) => {
          resolve({ data: response.connections, nextToken: response.nextToken });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
});

export const toConnectionId = (connectionId?: string | null): ConnectionId | null => {
  return connectionId ? { connectionId } : null;
};
